<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input v-model="listQuery.text" placeholder="请输入文本类型" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
      <el-select v-model="listQuery.select" placeholder="请选择下拉框" clearable>
        <el-option v-for="item in selectDict" :key="item.value" :label="item.label" :value="item.value"></el-option>

      </el-select>
      <el-date-picker v-model="listQuery.date" type="datetimerange" align="right" value-format="yyyy-MM-dd HH:mm:ss" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"></el-date-picker>
      <el-input v-model="listQuery.create_time" placeholder="请输入创建时间" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
      <el-input v-model="listQuery.update_time" placeholder="请输入更新时间" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
      <el-input v-model="listQuery.delete_time" placeholder="请输入删除时间" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />

      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
    </div>
    <!--动作组-->
    <div class="action-container">
      <el-button-group>
        <!-- 弹窗层编辑 -->
        <el-button v-auth="'ViewDemo.create'" class="action-item" type="primary" icon="el-icon-edit" @click="HandleCreate">添加</el-button>
        <el-button v-auth="'ViewDemo.delete'" class="action-item" icon="el-icon-delete" @click="BatchDelete">删除</el-button>
        // 导入-待开发
        // 下载模板-待开发
        <el-button v-auth="'ViewDemo.export'" class="action-item" icon="el-icon-download" type="primary" @click="exportPopup = true"> 导出 </el-button>

      </el-button-group>
    </div>
    <!--表开始-->
    <el-table ref="singleTable" v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%" @sort-change="sortChange">
      <!--列开始-->
      <el-table-column type="selection"></el-table-column>
      <el-table-column type="index" label="序号" width="55" :index="indexMethod" align="center" />
      <el-table-column align="center" prop="text" label="文本类型 "> </el-table-column>
      <el-table-column align="center" prop="password" label="密码类型 "> </el-table-column>
      <el-table-column align="center" prop="textarea" label="文本域 "> </el-table-column>
      <el-table-column align="center" prop="input_number" label="数字输入框 "> </el-table-column>
      <el-table-column align="center" prop="input_tag" label="标签输入框 "> </el-table-column>
      <el-table-column align="center" prop="switch" label="开关 "> </el-table-column>
      <el-table-column align="center" prop="slider" label="滑块 "> </el-table-column>
      <el-table-column align="center" prop="select" label="下拉框 "> </el-table-column>
      <el-table-column align="center" prop="radio" label="单选框 "> </el-table-column>
      <el-table-column align="center" prop="checkbox" label="复选框 "> </el-table-column>
      <el-table-column align="center" prop="date" label="日期 "> </el-table-column>
      <el-table-column align="center" prop="time" label="时间 "> </el-table-column>
      <el-table-column align="center" prop="upload" label="上传 "> </el-table-column>
      <el-table-column align="center" prop="editor" label="富文本 "> </el-table-column>
      <el-table-column align="center" prop="rate" label="评分器 "> </el-table-column>
      <el-table-column align="center" prop="create_time" label="创建时间 "> </el-table-column>
      <el-table-column align="center" prop="update_time" label="更新时间 "> </el-table-column>
      <el-table-column align="center" prop="delete_time" label="删除时间 "> </el-table-column>

      <el-table-column align="center" prop="" label="操作" width="200" class-name="action">
        <template slot-scope="scopes">
          <el-button v-auth="'ViewDemo.update'" plain icon="el-icon-edit" size="mini" @click="HandleUpdate(scopes.row)">编辑</el-button>
          <el-button v-auth="'ViewDemo.delete'" plain icon="el-icon-delete" size="mini" @click="RowDelete(scopes.row)">删除</el-button>

        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="loadData" />
    <!--弹窗编辑/新增窗体-->
    <el-dialog :title="dialogStatus=='create'?'新增':'编辑'" :visible.sync="dialogFormVisible">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="110px" style="width: 100%;">
        <el-form-item label="文本类型" prop="text">
          <el-input v-model="temp.text" />
        </el-form-item>
        <el-form-item label="密码类型" prop="password">
          <el-input v-model="temp.password" type="password" />
        </el-form-item>
        <el-form-item label="文本域" prop="textarea">
          <el-input v-model="temp.textarea" type="textarea" autosize />
        </el-form-item>
        <el-form-item label="数字输入框" prop="input_number">
          <el-input-number v-model="temp.input_number" :min="1" :max="10" :step="2" :precision="2" />
        </el-form-item>
        <el-form-item label="标签输入框" prop="input_tag">
          <el-input v-model="temp.input_tag" />
        </el-form-item>
        <el-form-item label="开关" prop="switch">
          <el-switch v-model="temp.switch" active-color="#13ce66" inactive-color="#ff4949" active-value="启用" inactive-value="停用"></el-switch>
        </el-form-item>
        <el-form-item label="滑块" prop="slider">
          <el-slider v-model="temp.slider" :min="1" :max="10" :step="1" show-stops> </el-slider>
        </el-form-item>
        <el-form-item label="下拉框" prop="select">
          <el-select v-model="temp.select" placeholder="请选择" multiple>
            <el-option v-for="item in selectDict" :key="item.value" :label="item.label" :value="item.value"></el-option>

          </el-select>
        </el-form-item>
        <el-form-item label="单选框" prop="radio">
          <el-radio v-for="item in radioDict" :key="item.value" v-model="temp.radio" :label="item.value">{{ item.label }}</el-radio>

        </el-form-item>
        <el-form-item label="复选框" prop="checkbox">
          <el-checkbox-group v-model="temp.checkbox">
            <el-checkbox v-for="item in checkboxDict" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>

          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="日期" prop="date">
          <el-date-picker v-model="temp.date" type="year" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>

        </el-form-item>
        <el-form-item label="时间" prop="time">
          <el-date-picker v-model="temp.time" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"> </el-date-picker>
        </el-form-item>
        <el-form-item label="上传" prop="upload">
          <FileList v-model="temp.upload" :item-width="360" :item-height="150" :limit="1" type="image" />
        </el-form-item>
        <el-form-item label="富文本" prop="editor">
          <WangEditor v-model="temp.editor" :value.sync="temp.editor" />
        </el-form-item>
        <el-form-item label="评分器" prop="rate">
          <el-rate v-model="temp.rate"></el-rate>
        </el-form-item>
        <el-form-item label="创建时间" prop="create_time">
          <el-input v-model="temp.create_time" />
        </el-form-item>
        <el-form-item label="更新时间" prop="update_time">
          <el-input v-model="temp.update_time" />
        </el-form-item>
        <el-form-item label="删除时间" prop="delete_time">
          <el-input v-model="temp.delete_time" />
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="ConfirmData">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/demo/view_demo' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
import WangEditor from '@/components/WangEditor'
import FileList from '@/components/attachment/FileList'
import dict_data from '@/api/system/dict_data'

export default {
  name: 'ViewDemo',
  components: { Pagination, WangEditor, FileList },
  // 列绑定格式化器
  filters: {
  },
  mixins: [commonList],
  data() {
    return {
      // api接口方法
      api,
      // 校验
      rules: {
      },
      temp: {},
      listQuery: {
        page: 1,
        limit: 10, // 页大小
        order: 'DESC', // 默认排序方式,
        sort: 'id'
      },
      // 字典参数
      selectDict: [],
      radioDict: [],
      checkboxDict: []

      // 字典参数
    }
  },
  created() {
    this.loadData()
    dict_data.Query({ sort: 'sort', order: 'asc', isPaginator: false, code: 'scs' }).then(response => {
      this.selectDict = response.data
    })
    dict_data.Query({ sort: 'sort', order: 'asc', isPaginator: false, code: 'scs' }).then(response => {
      this.radioDict = response.data
    })
    dict_data.Query({ sort: 'sort', order: 'asc', isPaginator: false, code: 'scs' }).then(response => {
      this.checkboxDict = response.data
    })
  },
  methods: {
    resetTemp() {
      this.temp = {
        id: undefined,
        order_no: 1,
        text: '',
        password: '',
        textarea: '',
        input_number: 1,
        input_tag: '',
        slider: 1,
        checkbox: [],
        create_time: '',
        update_time: '',
        delete_time: ''

      }
    }

  }
}
</script>
